import { render } from "./Carrusel.vue?vue&type=template&id=35e44eac&scoped=true"
import script from "./Carrusel.vue?vue&type=script&lang=js"
export * from "./Carrusel.vue?vue&type=script&lang=js"

import "./Carrusel.vue?vue&type=style&index=0&id=35e44eac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35e44eac"]])

export default __exports__